<app-header></app-header>
<div class="wrapper gener-wrap" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()" [infiniteScrollDisabled]="shimarStatus">
  <section class="related-search upcoming" *ngIf="!shimarStatus && favoriteData?.length > 0">
    <div class="container">
      <div class="">
        <div class="section-head head-pr-0">
          <h2 class="mb-0">{{ "FAV_LIST.MY_LIST" | translate }}</h2>
        </div>
      </div>
      <div class="row custome-set" *ngIf="favoriteData?.length > 0">
        <div class="series-box" *ngFor="let watch of favoriteData; let i = index" [hidden]="watch.content.length==0">
          <div>
            <app-grid [watchingStatus]="false" [data]="watch.content" [gridType]="'landscape'">
            </app-grid>
          </div>
        </div>
      </div>
    </div>

    <app-grid-simmer class="search-page" *ngIf="loadMore && favoriteData?.length > 0"></app-grid-simmer>
  </section>
  <app-grid-simmer class="search-page" *ngIf="shimarStatus"></app-grid-simmer>
  <div class="record-not-available" *ngIf="favoriteData?.length == 0 && !shimarStatus">
    <div class="text-center">
      <img src="assets/images/watchlist-error.png" />
      <p class="no-recored-content text-secondary">
        {{ "FAV_LIST.EXPLORING_MESSAGE" | translate }}
      </p>
      <button type="button" class="btn btn-theme mt-3" [routerLink]="['/videos']">
        {{ "FAV_LIST.START_EXPLORING" | translate }}
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>